import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Sidebar.css";

const Sidebar = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { admin } = useAuth();

  const menuItems = [
    {
      path: "/admin/dashboard",
      label: "Dashboard",
      icon: "📊",
      gradient: "from-orange-500 to-red-500",
    },
    {
      path: "/admin/apps",
      label: "Apps",
      icon: "📱",
      gradient: "from-blue-500 to-cyan-500",
    },
    {
      path: "/admin/blogs",
      label: "Blog",
      icon: "📝",
      gradient: "from-purple-500 to-pink-500",
    },
    {
      path: "/admin/contacts",
      label: "Contacts",
      icon: "📧",
      gradient: "from-green-500 to-emerald-500",
    },
  ];

  if (admin?.role === "super_admin") {
    menuItems.push({
      path: "/admin/admins",
      label: "Admins",
      icon: "👥",
      gradient: "from-indigo-500 to-purple-500",
    });
  }

  return (
    <>
      <button
        className="mobile-sidebar-toggle"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        aria-label="Toggle sidebar"
      >
        <span className="toggle-icon">☰</span>
      </button>

      <aside className={`admin-sidebar ${isMobileOpen ? "mobile-open" : ""}`}>
        {/* Gradient Background */}
        <div className="sidebar-gradient"></div>

        {/* Header */}
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="logo-icon-wrapper">
              <span className="logo-icon">🚀</span>
              <div className="logo-glow"></div>
            </div>
            <div className="logo-text">
              <h2>LICO</h2>
              <p>Admin Dashboard</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <div className="nav-label">MAIN MENU</div>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileOpen(false)}
            >
              <div className="nav-item-bg"></div>
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label-text">{item.label}</span>
              <div className="nav-indicator"></div>
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <div className="admin-card">
            <div className="admin-avatar-wrapper">
              <div className="admin-avatar">
                {admin?.name?.charAt(0).toUpperCase() || "A"}
              </div>
              <div className="admin-status"></div>
            </div>
            <div className="admin-info">
              <p className="admin-name">{admin?.name || "Admin"}</p>
              <p className="admin-role">{admin?.role || "admin"}</p>
            </div>
          </div>
        </div>
      </aside>

      {isMobileOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setIsMobileOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
